import {Switch} from 'platform/components';
import {HStack} from 'platform/foundation';

import {
  useIsPublishingMultiBranchEnabledQuery,
  useSetPublishingMultiBranchEnabledMutation,
} from '@dms/api/settings';
import {i18n} from '@dms/i18n';
import {testIds} from '@dms/routes';
import {handleApiError} from '@dms/shared';

import {useAdvertisingPlatformBranchQuerySync} from '../hooks/useAdvertisingPlatformBranchQuerySync';
import {AdvertisingPlatformBranchChoice} from './AdvertisingPlatformBranchChoice';

export function MultiBranchControl() {
  useAdvertisingPlatformBranchQuerySync();

  const {data: isMultiBranch, isLoading: isMultiBranchLoading} =
    useIsPublishingMultiBranchEnabledQuery();
  const [setMultiBranch] = useSetPublishingMultiBranchEnabledMutation();

  const onMultiBranchChange = (isEnabled: boolean) => {
    setMultiBranch(isEnabled).unwrap().catch(handleApiError);
  };

  return (
    <HStack align="center" spacing={4}>
      <Switch
        label={i18n.t('entity.advertisingPlatforms.labels.allowMultiBranch')}
        helperText={i18n.t('entity.advertisingPlatforms.labels.allowMultiBranchDescription')}
        value={!!isMultiBranch}
        isLoading={isMultiBranchLoading}
        onChange={onMultiBranchChange}
        data-testid={testIds.settings.advertisingPlatforms('allowMultiBranch')}
      />
      <AdvertisingPlatformBranchChoice />
    </HStack>
  );
}
